import React from 'react';
import { Row, Col } from 'reactstrap';

function About() {
  return (
    <Row>
      <Col>
        <h2>About Me</h2>
        <p>
          Hi, I’m wattson_x, a professional video editor with experience creating content for YouTube and TikTok. I've worked with a variety
          of clients, from smaller content creators to giants in the industry. I specialize in turning livestream footage into engaging
          content, adding value to otherwise unused material. If you're interested in transforming stream highlights into captivating
          videos, feel free to reach out to me.
        </p>
        <p>I’ve collaborated on sponsorships with several well-known companies, including:</p>
        <ul>
          <li>Porsche, Samsung, Chevron, Destiny 2, HyperX, Razer, DraftKings, and many more</li>
        </ul>
      </Col>
    </Row>
  );
}

export default About;
